var $body,
    $postGrid,
    $showMore,
    $filterInput,
    $postIntegrations,
    $noResults,
    $integrationType;

var loadMoreAmount = 6;


$(document).ready(function ($) {

    $showMore = $('.js-show-more');
    $postGrid = $('.js-post-grid');
    $filterInput = $('.js-input-filter');
    $postIntegrations = $('.js-post-integration');
    $noResults = $('.js-no-results');
    $integrationType = $('.js-type-name');

    $showMore.click(function (event) {
        event.preventDefault();
        showNextPosts(event);
    });

    $filterInput.keyup(function () {
        var input = $(this).val();
        var i = new RegExp("" + input, "i");
        var count = 0;
        $postIntegrations.each(function () {
            var check = i.test($(this).data("title"));
          $(this).toggle(check);
          $(this).removeClass('is-hidden');
            if (check) {
                count++;
            }
        });

        var hasResult = count > 0;
        $noResults.toggle(!hasResult);

        $showMore.hide();
        $integrationType.hide();
        if(!input.length){
            $integrationType.show();
        }
    });
});


// Functions

function showNextPosts(event) {
  let $categorie = $(event.currentTarget).parents('.c-posts-grid');
  let $hiddenPosts = $categorie.find('.c-post--integration.is-hidden');
  let $showMore = $categorie.find('.js-show-more');
  
  $hiddenPosts.slice(0, loadMoreAmount).show().removeClass('is-hidden');
  if ($hiddenPosts.length <= loadMoreAmount) {
      $showMore.hide();
  }
}

